module.exports = __webpack_public_path__ + "img/real-time-2.b7b1c9c7.png";